import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSocialLinks, type SocialLink } from '../services/api/social';
import { getSetting } from '../services/api/settings';
import './ContactPage.css';

type SiteSetting = { booking_email?: string };

export default function ContactPage() {
  const { t } = useTranslation();
  const [links, setLinks] = useState<SocialLink[]>([]);
  const [bookingEmail, setBookingEmail] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getSocialLinks(),
      getSetting<SiteSetting>('site').then((s) => s?.booking_email ?? ''),
    ])
      .then(([l, email]) => {
        setLinks(l);
        setBookingEmail(email);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-loading">{t('common.loading')}</div>;

  return (
    <div className="contact-page page">
      <h1 className="contact-page__title">{t('nav.contact')}</h1>
      <p className="contact-page__intro">
        {t('contact.reach_out', 'Reach out via social links or booking email.')}
      </p>

      {bookingEmail && (
        <section className="contact-page__section">
          <h2 className="contact-page__section-title">{t('contact.booking', 'Booking / Enquiries')}</h2>
          <a href={`mailto:${bookingEmail}`} className="contact-page__email">
            {bookingEmail}
          </a>
        </section>
      )}

      <section className="contact-page__section">
        <h2 className="contact-page__section-title">{t('contact.social', 'Social')}</h2>
        <div className="contact-page__links">
          {links.map((link) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-page__link"
            >
              {link.platform}
            </a>
          ))}
        </div>
        {links.length === 0 && <p className="contact-page__empty">{t('contact.no_links', 'No social links yet.')}</p>}
      </section>
    </div>
  );
}
